import { Controller } from '@hotwired/stimulus';
import { useClickOutside } from 'stimulus-use';

export default class extends Controller {
  static targets = ['listbox', 'button', 'input'];

  static values = {
    searchPath: String,
  };

  connect() {
    useClickOutside(this, { element: this.element });
  }

  clickOutside = () => {
    this.close();
  };

  clear() {
    this.inputTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });
  }

  toggle() {
    const open = !this.listboxTarget.hidden;

    this.listboxTarget.hidden = open;
    this.buttonTarget.setAttribute('aria-expanded', !open);
  }

  close() {
    this.listboxTarget.hidden = true;
    this.buttonTarget.setAttribute('aria-expanded', false);
  }
}
